class OptionPopupTrigger extends HTMLElement {
  constructor() {
    super();

    this.handleButtonClick = (e) => {
      const targetPopupId = this.dataset.controls;
      this.button.dispatchEvent(
        new CustomEvent("option-popup:toggle", {
          bubbles: true,
          detail: { id: targetPopupId },
        }),
      );
    };
  }

  connectedCallback() {
    this.button = this.closest("button");

    if (!this.button) return;

    this.button.addEventListener("click", this.handleButtonClick);
  }

  disconnectedCallback() {
    this.button.removeEventListener("click", this.handleButtonClick);
  }
}

if (!customElements.get("option-popup-trigger")) {
  customElements.define("option-popup-trigger", OptionPopupTrigger);
}
